import { cmxUrl, registrationUrl } from 'endpoints';
import fetch from '../utils/fetch';

class SelfRegistraionSDK {
  // Update Client Registration by id
  updateClient = data => {
    data.active = true;
    return new Promise( ( resolve, reject ) => {
      fetch( `${ registrationUrl }/registration-client/${ data.registrationId }`, {
        method: 'PUT',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify( data )
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( client => {
              resolve( client );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };
  // Create a client registration
  registerClient = data => {
    // console.log( data );
    return new Promise( ( resolve, reject ) => {
      fetch( `${ registrationUrl }/registration-client`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify( data )
      } )
        .then( res => {
          if ( res.ok ) {
            res.json().then( client => {
              resolve( client );
            } );
          } else {
            res.json().then( data => {
              reject( 'Client code already exists' );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };
  // Get clients
  getClients = () => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${ registrationUrl }/registration-clients` )
        .then( res => {
          if ( res.ok ) {
            res.json().then( clients => {
              resolve( clients );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };

  // Get clients
  getLocales = () => {
    return new Promise( ( resolve, reject ) => {
      fetch( `${ cmxUrl }/locales` )
        .then( res => {
          if ( res.ok ) {
            res.json().then( locales => {
              resolve(
                locales.locales.map( item => {
                  const obj = {};
                  obj.value = item.code;
                  obj.label = item.label_enUS;
                  return obj;
                } )
              );
            } );
          } else {
            res.json().then( data => {
              reject( data.message );
            } );
          }
        } )
        .catch( err => {
          console.error( err );
          reject( err.message );
        } );
    } );
  };
}

export default new SelfRegistraionSDK();
